import { PREDES_TRANSACTIONS_OBJECT_REQUEST, PREDES_TRANSACTIONS_OBJECT_SUCCESS, PREDES_TRANSACTIONS_OBJECT_FAILURE } from './types/PredesTransactionsObjectActionsTypes';

export function postPredesTransactionsObjectRequestActionCreator(context,
  newDescription,
  newQuantity,
  newTransactionId) {
  return {
    type: PREDES_TRANSACTIONS_OBJECT_REQUEST,
    payload: {
      appContext: context,
      params: {
        comments: newDescription,
        quantity: newQuantity,
        transactionId: newTransactionId,
      },
    },
  };
}

export function postPredesTransactionsObjectSuccessActionCreator(data) {
  return {
    type: PREDES_TRANSACTIONS_OBJECT_SUCCESS,
    payload: data,
  };
}

export function postPredesTransactionsObjectFailureActionCreator(error) {
  return {
    type: PREDES_TRANSACTIONS_OBJECT_FAILURE,
    payload: error,
    error: true,
  };
}
